export const nodeParams = {
	width: 150,
	height: 50,
};
